import { render, staticRenderFns } from "./activityType.vue?vue&type=template&id=756c5436&"
import script from "./activityType.vue?vue&type=script&lang=js&"
export * from "./activityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports